import { gql } from "@apollo/client"

export const MY_SITE_SUBSCRIPTION = gql`
    subscription SiteSubscription {
        mySite {
            name
            status
            settings {
                general {
                    timezone
                    language
                }
            }
            type
            tier
        }
    }
`
